import React, {useCallback, useEffect, useState, useRef} from 'react'
import { useLocation } from 'react-router-dom';
import {useSubheader} from '../../../../_metronic/layout'
import {Tab, Nav, Table} from 'react-bootstrap'
import {OrderStatus} from './OrderStatus'
import {getAccountInfo, getQNA, updateOrder} from '../../Wizard/_redux/wizardCrud'
import {OrderInformation} from './OrderInformation'
import {OrderDesign} from './OrderDesign'
import {OrderQnA} from './OrderQnA'
import k1utils from '../../../../util/k1utils'
import {
  cancelSwal,
  confirmSwal,
  order5030Swal,
  order5040Swal,
  order5050Swal,
  order5060Swal,
  order5070Swal,
  orderCancelSwal,
  orderSwal,
  paymentSwal, // 카드결제 컨펌
} from '../../../../util/Swals'
import {SET_STATUS} from '../../Notification/page/Notification'
import {TableBody} from '@mui/material'
import moment from 'moment'
import {WORK_TYPE_BOOKN, WORK_TYPE_ORDER} from '../../Wizard/WizardConstants'
import { ReactInicis } from '../../Inicis/ReactInicis' 
import {loadTossPayments} from '@tosspayments/payment-sdk'
import "./inicisOrder.css"
import Swal from 'sweetalert2'
const getPrice = (data) => {
  if (data.order_status === 5030) {
    let str =
      `예상 금액 : ${k1utils.priceFormat(data.price_min * data.quantity)} ~ ${k1utils.priceFormat(
        data.price_max * data.quantity
      )} ` + (data.quantity !== 1 ? '(예상 단가 * 수량)' : '')
    return str
  } else {
    let str =
      (data.quantity !== 1
        ? `[단가 : ${k1utils.priceFormat(data.price)} * 수량 : ${data.quantity}] `
        : '') + `금액 : ${k1utils.priceFormat(data.price * data.quantity)}`

    return str
  }
}

const getUnitPrice = (data) => {
  if (data.order_status === 5030) {
    let str = `예상 단가 : ${k1utils.priceFormat(data.price_min)} ~ ${k1utils.priceFormat(
      data.price_max
    )}`
    if (data.is_delivery === 'Y') {
      const delivery = data.order_value.find((item) => item.t_order_item_name === '배송 여부')
      str += ` (배송비 : ${k1utils.priceFormat(delivery.price_min)} ~ ${k1utils.priceFormat(
        delivery.price_max
      )})`
    }
    return str
  } else {
    return `단가 : ${k1utils.priceFormat(data.price)}`
  }
}

export function OrderSheet({data, store, dispatch, calStep, workTypeValue, paymentCard}) {
  const location = useLocation();
  const suhbeader = useSubheader()
  // suhbeader.setTitle(`${store.name} - ${data.t_order_formname}`)
  const [account, setAccount] = useState([])
  const [qna, setQna] = useState([])
  const [key, setKey] = useState('OrderInformation')
  const tossPaymentsRef = useRef(null)
  const [isShow, setIsShow] = useState(false)
  const onConfirm = useCallback(() => {
    const updateData = {
      idx: data.idx,
      order_status: 5050,
    }
    confirmSwal(data, workTypeValue).then((result) => {
      if (result.value) {
        orderSwal(workTypeValue).then(() =>
          updateOrder(updateData)
            .then(() => dispatch({type: SET_STATUS, status: updateData.order_status}))
            .catch((err) => console.error(err))
        )
      }
    })
  }, [data, dispatch, workTypeValue])

  const [isPurchase, setIsPurchase] = useState(0);

  const [payData, setPayData] = useState({
      oid:data.order_key,
      productName:data.t_order_formname,
      buyerName:data.buyer_name,
      buyerTel:data.buyer_mobile_phone,
      buyerEmail:data.buyerEmail,
      productPrice:data.price * data.quantity + data.price_delivery,
      payStatus:0,
      returnUrl:process.env.REACT_APP_API_SERVER_URL + "/front/inicisPay",
      closeUrl: process.env.REACT_APP_LOCALHOST + "/k/" + data.order_key,
      // closeUrl: "http://" + process.env.REACT_APP_DOMAIN + "/k/" + data.order_key,

  })


  const _chooseMethod = (method) => {
    // String for 'toss payment'
    switch (method) {
      case 'CARD':
        return '카드'
      case 'ACTX':
        return '계좌이체'
      default:
        return '카드'
    }
  }

  const onPayment = useCallback(
    (method = 'CARD') => {
      // const updateData = {
      //   idx: data.idx,
      //   order_status: 5050,
      // }
      if (null == tossPaymentsRef) {
        alert('toss init fail')
        return
      }

      paymentSwal(data).then((result) => {
        if (result.value) {
          const pay_method = _chooseMethod(method)
          // const pay_method_k = _chooseMethodK(method)

          const callbackUrl = k1utils.isDev()
            ? `http://localhost:3005/${method}`
            : `https://${process.env.REACT_APP_DOMAIN}/${method}`

          tossPaymentsRef.current
            .requestPayment(pay_method, {
              amount: data.price * data.quantity + data.price_delivery,
              orderId: data.order_key,
              orderName: data.t_order_formname,
              customerName: data.buyer_name,
              successUrl: callbackUrl + `/success`,
              failUrl: callbackUrl + `/fail`,
            })
            .then((data) => {
              console.log('결제 요청 성공 [' + JSON.stringify(data) + ']')
              console.log('**** 여기 안와요! ****')
              debugger
            })
            .catch((error) => {
              console.error('ERROR! [' + error.code + ':' + error.message + ']')
              if (error.code === 'USER_CANCEL') {
                // 결제 고객이 결제창을 닫았을 때 에러 처리
              } else if (error.code === 'INVALID_CARD_COMPANY') {
                // 유효하지 않은 카드 코드에 대한 에러 처리
              } else if (error.code === 'DUPLICATE_ORDER_ID') {
                // 이미 승인 및 취소가 진행된 중복된 주문번호입니다.
              }
            })
        }
      })
    },
    [data, tossPaymentsRef]
  )

  const onCancel = useCallback(() => {
    const updateData = {
      idx: data.idx,
      order_status: 5070,
    }
    cancelSwal(workTypeValue).then((result) => {
      if (result.value) {
        orderCancelSwal().then(() =>
          updateOrder(updateData)
            .then(() => dispatch({type: SET_STATUS, status: updateData.order_status}))
            .catch((err) => console.error(err))
        )
      }
    })
  }, [data, dispatch, workTypeValue])

  const accountData = useCallback(() => {
    store &&
      getAccountInfo(store.idx, data.t_order_formidx)
        .then((res) => {
          const result = res.data
          if (result.message === 'Success') {
            setAccount(result.data)
          }
        })
        .catch((err) => console.error(err))
  }, [store])

  const qnaData = useCallback(() => {
    data.idx &&
      getQNA(data.idx)
        .then((res) => {
          const result = res.data
          // if (result.length > 0) {
          setQna(result)
          // }
        })
        .catch((err) => console.error(err))
  }, [data])

  useEffect(() => {
    accountData()
    qnaData()
  }, [accountData, qnaData])

  useEffect(() => {
    const param = new URLSearchParams(location.search);
    const alarm = param.get('alarm');
    if(null === alarm){
        switch (data.order_status) {
          case 5030: {
            order5030Swal(workTypeValue)
            break
          }
          case 5040: {
            order5040Swal(data.message, workTypeValue)
            break
          }
          case 5050: {
            order5050Swal(workTypeValue)
            break
          }
          case 5060: {
            order5060Swal(workTypeValue)
            break
          }
          case 5070 || 5080: {
            order5070Swal(workTypeValue)
            break
          }
          default:
            return
        }
  } else {
      Swal.fire({
        title: '결제실패',
        text : alarm,
        icon: 'warning',
        confirmButtonText: '확인'
      });
  }
  }, [data.order_status, data.message, workTypeValue])

  const paymentButton = () => {
    return (
      <div className='btn-group'>
        <button
          type='button'
          className='btn btn-info font-weight-bolder text-uppercase px-4 py-2 mr-1'
          onClick={() => setIsPurchase(isPurchase+1) }
        >
          카드결제
        </button>
        <ReactInicis payData={payData} isPurchase={isPurchase} isTest />
        <button
          type='button'
          className='btn btn-secondary font-weight-bolder text-uppercase px-4 py-2 mr-1'
          onClick={() => onPayment('ACTX')}
        >
          계좌이체
        </button>
      </div>
    )
  }

  const typeName = workTypeValue !== 'ORDER' ? WORK_TYPE_BOOKN : WORK_TYPE_ORDER

  function refundView() {
    return (
      <details>
        <hr />
        <summary>
          <span style={{color: '#22222', fontSize: '12px', fontWeight: 'bold'}}>환불 및 교환 규정</span>
        </summary>
        <b>
          <big>
            1. 환불의 범위는 회사가 이용자에게 제공하는 유형(재화 상품)에 대한 환불을 진행한다.{' '}
          </big>
          <br />
        </b>
        <b>
          <big>2. 제공되는 유형 상품의 환불은 구분된 별도의 규정을 통해 진행한다. </big>
        </b>
        <br />
        <b>
          <big>3. 환불에 대한 문의와 물품반송은 아래와 같다. </big>
        </b>
        <br />
        <Table bordered striped>
          <tbody>
            <tr className='p-0'>
              <th className='bg-dark text-white'>문의처</th>
              <td>물품을 제공받을 곳의 SNS 혹은 카카오톡</td>
            </tr>
            <tr className='p-0'>
              <th className='bg-dark text-white'>보내실 곳</th>
              <td>물품을 받으신 공방</td>
            </tr>
          </tbody>
        </Table>
        <b>
          <big>4. 유형(재화상품)상품에 대한 철회 및 환불규정은 다음과 같다. </big>
        </b>
        <br />
        <div> 1) 제공된 재화 상품은 공급받은 날로부터 7일 이내 철회가 가능하다.</div>
        <div> 2) 단, 다음 어느 하나에 해당하는 경우에는 철회가 불가능하다</div>
        <Table bordered striped>
          <tbody>
            <tr className='p-0'>
              <td>
                ① 이용자의 잘못으로 재화가 멸실(물건의 기능을 할 수 없을 정도로 파손된 상태) 되거나
                훼손된 경우(단, 내용물을 확인하기 위해 배송 박스 등 외부 포장을 훼손한 경우에는 철회
                가능하나 물품 개별 자체 포장 훼손된 경우는 철회 불가) <br />
                ② 이용자가 사용해서 물건의 가치가 뚜렷하게 떨어진 경우 <br />
                ③ 다시 공급 및 판매가 곤란할 정도로 물건의 가치가 뚜렷하게 떨어진 경우 <br />
                ④ 복제가 가능한 물건의 포장을 훼손한 경우 <br />⑤ 이용자의 주문에 따라 개별적으로
                생산되는 상품 또는 이와 유사한 상품 등의 청약철회 및 계약해제를 인정하는 경우 인터넷
                쇼핑몰 사업자에게 회복할 수 없는 중대한 피해가 <br />
                예상되는 경우로서 사전에 주문 취소 및 반품이 되지 않는다는 사실을 별도로 알리고
                소비자의 서면(전자문서 포함)에 의한 동의를 받은경우
              </td>
            </tr>
          </tbody>
        </Table>
        <div>
          {' '}
          3) 제공된 유형 상품이 이벤트 및 기획전 등을 통해 무상으로 제공되었더라도 제공일로부터 7일
          이후 무형상품의 철회 및 환불 요청 시 무상으로 제공받은 유형상품은 그 가치를 인정하여
          무형상품 환불 금액에서 유형상품의 가격을 제외 후 환불한다
        </div>
        <div>
          {' '}
          4) 유형상품 철회 진행 시 배송비는 본인 부담으로 진행하며 환불금액 책정 시, 차감되어
          진행된다.
        </div>
        <div>
          {' '}
          5) 교환 및 환불된 제품은 담당부서에서 확인하여 제품 검수(개봉 여부 및 포장상태 확인 등) 후
          최종 환불이 완료됩니다. (제품 회수 후 최대 10일 소요)
        </div>
      </details>
    )
  }

  return (
    <>
      {/* Head */}
      <div className='card-header border-0 p-3 '>
        <div className='w-100 text-center'>
          {/*<Image roundedCircle src={k1utils.toSmallFileUrl(data.t_order_form_file_idx)} width={60}/>*/}
          <OrderStatus
            step={(data.order_status - 5020) / 10}
            calStep={calStep}
            workTypeValue={workTypeValue}
          />
        </div>
        <Table bordered striped>
          {/*<thead className="thead-light">*/}
          {/*<tr>*/}
          {/*    <th colSpan={2} >*/}
          {/*        고객 정보*/}
          {/*    </th>*/}
          {/*</tr>*/}
          {/*</thead>*/}
          <tbody>
            <tr className='p-0'>
              <th className='bg-dark text-white'>
                {/*<i className="fas fa-user text-dark font-size-xs"></i> */}
                이름
              </th>
              <td>{data.buyer_name}</td>
            </tr>
            <tr className='p-0'>
              <th className='bg-dark text-white'>
                {/*<i className="fas fa-mobile-alt text-dark font-size-xs"></i> */}
                연락처
              </th>
              <td>{k1utils.phoneNumberFormat(data.buyer_mobile_phone)}</td>
            </tr>
            <tr className='p-0'>
              <th className='bg-dark text-white'>
                {/*<i className="far fa-calendar-alt text-dark font-size-xs"></i> */}
                픽업
              </th>
              <td>{moment(data.pickup_dtm).format('YYYY-MM-DD HH:mm')}</td>
            </tr>
          </tbody>
        </Table>
      </div>
      {/* begin::Body */}
      <div className={`tab-content card-body p-3`} id='myTabTables12'>
        <div className='card-toolbar'>
          <Tab.Container defaultActiveKey={key}>
            <Nav
              as='ul'
              onSelect={(_key) => setKey(_key)}
              className='nav nav-pills nav-pills-sm nav-dark-75 '
            >
              <Nav.Item className='nav-item  ' as='li'>
                <Nav.Link
                  eventKey='OrderInformation'
                  className={`nav-link py-2 px-4 ${key === 'Month' ? 'active' : ''}`}
                  style={{borderRadius: 0}}
                >
                  {typeName}정보
                </Nav.Link>
              </Nav.Item>
              {/*<Nav.Item className="nav-item" as="li">*/}
              {/*    <Nav.Link*/}
              {/*        eventKey="OrderDesign"*/}
              {/*        className={`nav-link py-2 px-4 ${*/}
              {/*            key === "Week" ? "active" : ""*/}
              {/*        }`}*/}
              {/*        style={{borderRadius:0}}*/}
              {/*    >*/}
              {/*        세부 디자인*/}
              {/*    </Nav.Link>*/}
              {/*</Nav.Item>*/}
              <Nav.Item className='nav-item' as='li'>
                <Nav.Link
                  eventKey='QNA'
                  className={`nav-link py-2 px-4 ${key === 'Day' ? 'active' : ''}`}
                  style={{borderRadius: 0}}
                >
                  Q&A
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Tab.Container>
        </div>

        <div className={`tab-pane fade ${key === 'OrderInformation' ? 'show active' : ''}`}>
          <OrderInformation data={data} />
          <OrderDesign data={data.order_reference} />
        </div>

        {/*<div*/}
        {/*    className={`tab-pane fade ${key === "OrderDesign" ? "show active" : ""}`}>*/}

        {/*</div>*/}

        <div className={`tab-pane fade ${key === 'QNA' ? 'show active' : ''}`}>
          <OrderQnA data={data} qna={qna} qnaData={qnaData} />
        </div>

        {data.quantity !== 1 && (
          <div className='mb-1'>
            <span className='text-dark-75 font-weight-bolder text-hover-primary font-size-lg'>
              {getUnitPrice(data)}
            </span>
            <br />
          </div>
        )}

        {data.order_status === 5050 && (
          <Table bordered size='sm'>
            <TableBody>
              <tr>
                <th className='bg-dark text-white'>
                  <strong>입금 은행</strong>
                </th>
                {account.map((item, i) => (
                  <td key={'key-' + i}>{item.value}</td>
                ))}
              </tr>
            </TableBody>
          </Table>
        )}

        {!!data?.message && (
          <Table bordered size='sm' className={'mt-3'}>
            <TableBody>
              <tr>
                <th>추가메시지</th>
                <td style={{whiteSpace: 'pre-line'}}>{data.message}</td>
              </tr>
            </TableBody>
          </Table>
        )}

        <Table bordered size='sm'>
          <TableBody>
            <tr>
              <th>
                <strong>
                  <i className='fa fa-map font-size-xs text-dark'></i>&nbsp;&nbsp;{store.name}
                </strong>
              </th>
              <td>{store.address1}</td>
              <td>{store.address2}</td>
              <td>{store.zipcode}</td>
            </tr>
          </TableBody>
        </Table>
        <div className='d-flex align-items-end flex-column'>
          <span className='text-dark-75 font-weight-bolder text-hover-primary font-size-lg'>
            {getPrice(data)}
          </span>
          {data.is_delivery === 'Y' && (
            <span className='text-dark-75 font-weight-bolder text-hover-primary font-size-lg'>
              {data.order_status === 5030
                ? `( * 배송비 별도 )`
                : `배송비 : ${k1utils.priceFormat(data.price_delivery)}`}
            </span>
          )}
        </div>

        {data.order_status !== 5030 && (
          <Table bordered size='sm' className={'mt-3'}>
            <TableBody>
              <tr>
                <th>총 합계</th>
                <td className='text-right'>
                  <span
                    className='text-dark-75 font-weight-bolder text-hover-primary font-size-lg'
                    style={{whiteSpace: 'pre-wrap'}}
                  >
                    {k1utils.priceFormat(data.price * data.quantity + data.price_delivery)}
                  </span>
                </td>
              </tr>
            </TableBody>
          </Table>
        )}

        {/* begin:: Button*/}

        <div className='d-flex justify-content-end pt-2'>
          <div>
            {/* 가격 확인 요청 - 결제 버튼 */}
            {data.order_status === 5040 && paymentCard === 'true' && paymentButton()}

            {/* 가격 확인 요청 - 주문 하기 */}
            {data.order_status === 5040 && (
              <div className='btn-group'>
                <button
                  type='button'
                  className='btn btn-success font-weight-bolder text-uppercase px-4 py-2 mr-1'
                  onClick={onConfirm}
                >
                  {typeName}하기
                </button>
              </div>
            )}

            {/* 가격 확인 - 결제 버튼 */}
            {data.order_status === 5050 && paymentCard === 'true' && paymentButton()}

            {/* 취소 */}
            {data.order_status !== 5060 &&
              data.order_status !== 5065 &&
              data.order_status !== 5070 &&
              data.order_status !== 5080 &&
              data.order_status !== 5100 && (
                <button
                  type='button'
                  className='btn btn-danger font-weight-bolder text-uppercase px-4 py-2'
                  onClick={onCancel}
                >
                  취소하기
                </button>
              )}
            {(data.order_status === 5060 || data.order_status === 5065) && (
              <span className='text-info font-weight-bolder'>
                입금 후 취소는 카톡으로 연락주세요.
              </span>
            )}
            {(data.order_status === 5070 || data.order_status === 5080) && (
              <span className='text-danger font-weight-bolder'>취소된 {typeName}입니다.</span>
            )}
          </div>
        </div>
        {/* end:: Button*/}
        {paymentCard === 'true' && refundView()}
      </div>

      {/* end::Body */}
    </>
  )
}
